import React from 'react';
import IconDefault from '../../icons/IconDefault';

export default class StepHorizontalDoubleFieldItem extends React.Component {
    renderDefButton() {
        let renderButton = () => (
            <div style={{ margin: '0 5px' }} onClick={this.props.onDefaultButtonClick}>
                <IconDefault />
            </div>
        )

        let renderEmpty = () => (
            <span>
                &nbsp;
            </span>
        )

        return (
            <div className="heating-horizontal-field-default">
                {this.props.defaultButtonVisible ? renderButton() : renderEmpty()}
            </div>
        )
    }

    renderMetaData() {
        if (this.props.unit && this.props.defaultButtonVisible) {
            return (
                <React.Fragment>
                    <div className="field-column3">
                        {<span className="unit">{this.props.unit}</span>}
                    </div>
                    <div className="field-column3">
                        {this.renderDefButton()}
                    </div>
                </React.Fragment>
            )
        }
        if (this.props.unit) {
            return (
                <div className="field-column3">
                    {<span className="unit">{this.props.unit}</span>}
                </div>
            )
        }
        if (this.props.defaultButtonVisible) {
            return (
                <div className="field-column3">
                    {this.renderDefButton()}
                </div>
            )
        }
    }

    render() {
        if (this.props.visible === false) {
            return <React.Fragment></React.Fragment>
        }

        return (
            <div className="configuration-field-row" style={{ display: 'flex', alignItems: 'center', minHeight: '36px' }}>
                <div className="field-column1">
                    {this.props.label}
                </div>
                <div className="field-column2">
                    {this.props.children}
                </div>
                {this.renderMetaData()}
            </div>
        )
    }
}